import Link from "next/link"
import { ArrowRight, Camera, ShieldCheck, ThumbsUp } from "lucide-react"
import { Button } from "@/components/ui/button"

const STEPS = [
  {
    title: "Choose one good photo",
    body: "Add a title, your grass type if you know it, and the region you call home.",
    icon: Camera,
  },
  {
    title: "We review it",
    body: "Every submission is checked before it reaches the public gallery.",
    icon: ShieldCheck,
  },
  {
    title: "The community votes",
    body: "Approved lawns can earn votes and move up the all-time board.",
    icon: ThumbsUp,
  },
] as const

export function SubmitCta() {
  return (
    <section className="ds-glass mt-12 overflow-hidden rounded-[2rem] md:mt-16">
      <div className="grid lg:grid-cols-[0.72fr_1.28fr]">
        <div className="bg-green-950 px-6 py-8 text-white sm:px-8 md:py-10">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-green-300">How it works</p>
          <h2 className="font-editorial mt-3 text-4xl font-semibold leading-none md:text-5xl">
            Put your lawn on the board.
          </h2>
          <p className="mt-4 max-w-md text-sm leading-6 text-green-50/80 md:text-base">
            You do not need an account. We only publish your photo after a moderation check.
          </p>
          <Button asChild size="lg" className="mt-6 min-h-12 rounded-full bg-white px-6 text-green-950 hover:bg-green-50">
            <Link href="/community/submit">
              Share your lawn
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </Link>
          </Button>
        </div>

        <ol className="grid gap-px bg-green-950/10 sm:grid-cols-3">
          {STEPS.map(({ title, body, icon: Icon }, index) => (
            <li key={title} className="bg-white/55 p-6 md:p-7">
              <div className="flex items-center justify-between gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-green-100 text-green-800">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <span className="font-editorial text-2xl font-semibold text-green-950/25">0{index + 1}</span>
              </div>
              <h3 className="mt-5 text-base font-bold text-green-950">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-green-900/70">{body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
